import { AxiosError } from 'axios';

import { ZOR_DOCUMENT_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZorDocument } from '@/types/zor.document.type';

export const getAllZorDocuments = async (): Promise<
  ApiResponse<Array<ZorDocument>>
> => {
  try {
    const response = await apiManager.get(ZOR_DOCUMENT_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
